export default __webpack_public_path__ + "static/media/plane.08f0964f.png";